import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DockModule } from 'primeng/dock';
import { DragDropModule } from 'primeng/dragdrop';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PickListModule } from 'primeng/picklist';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';

@NgModule({
  imports: [
    CommonModule,
    RadioButtonModule,
    ToastModule,
    MegaMenuModule,
    DialogModule,
    DropdownModule,
    ConfirmDialogModule,
    MultiSelectModule,
    ToolbarModule,
    TableModule,
    InputSwitchModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ChartModule,
    InputTextModule,
    TreeTableModule,
    StepsModule,
    GalleriaModule,
    FileUploadModule,
    ButtonModule,
    ChipsModule,
    CalendarModule,
    ListboxModule,
    AutoCompleteModule,
    TabViewModule,
    CheckboxModule,
    SkeletonModule,
    ToggleButtonModule,
    MenubarModule,
    CardModule,
    DataViewModule,
    SplitButtonModule,
    SlideMenuModule,
    TooltipModule,
    CarouselModule,
    AccordionModule,
    PanelModule,
    InputNumberModule,
    MenuModule,
    BadgeModule,
    SelectButtonModule,
    TabMenuModule,
    InputTextareaModule,
    FieldsetModule,
    ChipModule,
    DragDropModule,
    InputMaskModule,
    OverlayPanelModule,
    DividerModule,
    SidebarModule,
    BreadcrumbModule,
    PickListModule,
    OrganizationChartModule,
    PaginatorModule,
    TimelineModule,
    ConfirmPopupModule,
    DockModule,
  ],
  exports: [
    RadioButtonModule,
    InputSwitchModule,
    MegaMenuModule,
    ToastModule,
    DialogModule,
    DropdownModule,
    ConfirmDialogModule,
    MultiSelectModule,
    ToolbarModule,
    TableModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ChartModule,
    InputTextModule,
    TreeTableModule,
    StepsModule,
    GalleriaModule,
    FileUploadModule,
    ButtonModule,
    ChipsModule,
    CalendarModule,
    ListboxModule,
    AutoCompleteModule,
    TabViewModule,
    CheckboxModule,
    SkeletonModule,
    ToggleButtonModule,
    MenubarModule,
    CardModule,
    DataViewModule,
    SplitButtonModule,
    SlideMenuModule,
    TooltipModule,
    CarouselModule,
    AccordionModule,
    PanelModule,
    InputNumberModule,
    MenuModule,
    BadgeModule,
    SelectButtonModule,
    TabMenuModule,
    InputTextareaModule,
    FieldsetModule,
    ChipModule,
    DragDropModule,
    InputMaskModule,
    OverlayPanelModule,
    DividerModule,
    SidebarModule,
    BreadcrumbModule,
    PickListModule,
    OrganizationChartModule,
    PaginatorModule,
    TimelineModule,
    ConfirmPopupModule,
    DockModule,
  ],
})
export class UiElementsModule {}
